import useState from "react-usestateref";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Logo from "../assets/logo.png";
import { AppBar, Drawer, ListItem, Toolbar } from "@material-ui/core";
import { TbWorld } from "react-icons/tb";
import "./style.css";
import { FaPhoneAlt } from "react-icons/fa";
import "react-phone-input-2/lib/style.css";
import { useEffect, useLayoutEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { gifItems, sidebarItems, tabContent } from "../utils/data";
import { Box, Modal } from "@material-ui/core";
import Skeleton from "@mui/material/Skeleton";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  appBarItems: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobileMenuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerIcon: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  drawer: {
    width: 300,
  },
}));

const ProjectNew = () => {
  const [menuopen, setMenuopn] = useState(false);

  const navigate = useNavigate();

  const handleAboutLogoClick = () => {
    localStorage.setItem("cameFromAbout", "true");
    navigate("/");
  };

  const [filteredImages, setFilteredImages] = useState([]);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const classes = useStyles();

  const [activeLink, setActiveLink] = useState("");
  const location = useLocation();

  // useEffect(() => {
  //   const path = location.pathname.split("/").pop();
  //   setActiveLink(path);
  // }, [location]);

  useEffect(() => {
    let path = location.pathname.split("/").filter(Boolean).pop();
    // fallback for root-level route like "/projects"
    if (!path) {
      path = location.pathname.replace("/", "");
    }
    setActiveLink(path || "projects"); // default to "projects"
  }, [location]);

  // const isActive = (path) => {
  //   return activeLink === path ? "active-link" : "";
  // };

  const isActive = (path) => {
    return location.pathname === `/${path}` ||
      location.pathname.startsWith(`/${path}/`)
      ? "active-link"
      : "";
  };

  //   route changes
  const { category } = useParams();

  const defaultTab = sidebarItems[0].key;

  const [activeTab, setActiveTab] = useState(category || defaultTab);


  const [loading, setLoading] = useState(true);


useEffect(() => {
  let isMounted = true;
  setLoading(true);
  setFilteredImages([]);

  if (!category) {
    navigate(`/projects/${defaultTab}`, { replace: true });
    setActiveTab(defaultTab);
    setLoading(false);
    return;
  }

  const currentTabData = tabContent[category];
  if (!currentTabData || currentTabData.length === 0) {
    setLoading(false);
    return;
  }

  setActiveTab(category);

  const validItems = currentTabData.filter(
    (item) => item.img && item.img !== ""
  );

  const loadImages = validItems.map(
    (item) =>
      new Promise((resolve) => {
        const img = new Image();
        img.src = item.img;
        img.onload = () => setTimeout(() => resolve(item), 100); 
        img.onerror = () => resolve(null);
      })
  );

  Promise.all(loadImages).then((loaded) => {
    if (!isMounted) return;

    const successful = loaded.filter(Boolean);
    setFilteredImages(successful);

   setLoading(false)
  });

  return () => {
    isMounted = false;
  };
}, [category, navigate]);


  const handleTabClick = (key) => {
    setActiveTab(key);
    navigate(`/projects/${key}`);
  };

  // right column scroll to top
  const rightColRef = useRef(null);
  useLayoutEffect(() => {
    const el = rightColRef.current;
    if (!el) return;

    const scrollToTopOfCards = () => {
      // 1) If the right column itself is scrollable, scroll it
      if (el.scrollHeight > el.clientHeight) {
        el.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }

      // 2) If some ancestor is the scroll container, scroll that
      let parent = el.parentElement;
      while (parent && parent !== document.body) {
        const style = getComputedStyle(parent);
        const oy = style.overflowY;
        if (oy === "auto" || oy === "scroll") {
          parent.scrollTo({ top: el.offsetTop, behavior: "smooth" });
          return;
        }
        parent = parent.parentElement;
      }

      // 3) Fallback: scroll the window so the right column aligns to viewport top
      const top = el.getBoundingClientRect().top + window.pageYOffset - 20; // adjust offset if needed
      window.scrollTo({ top, behavior: "smooth" });
    };

    // Ensure the browser has painted the new content before trying to scroll
    requestAnimationFrame(() => {
      // small timeout helps when images/layout still shift
      setTimeout(scrollToTopOfCards, 30);
    });
  }, [activeTab]);

  const [open, setOpen] = useState(false);

  const [selectedGifClass, setSelectedGifClass] = useState(null);

  console.log(selectedGifClass,'selectedGifClass====');
  

  const handleImageClick = (hoverClass) => {
    setSelectedGifClass(hoverClass);
    setOpen(true);
  };

  // Find the gif item that matches the selected class
  const selectedGifItem = gifItems.find(
    (item) => item.className === selectedGifClass
  );

  return (
    <>
      {" "}
      <div className="main-bg projects-bg">
        <section
          className={` ${
            menuopen === true ? "menuopenzindex" : "menuclosezindex"
          }`}
        >
          <header className="main-header scrolled header-wrapper">
            <AppBar position="static" className="header_secondsec">
              <Toolbar className="container-fluid p-0 w-100 justify-content-between header_toolbar">
                <div className="hd_navigation">
                  <div
                    className="d-flex hd_nav_lft"
                    onClick={handleAboutLogoClick}
                  >
                    <Link className="logo-wrapper">
                      <img src={Logo} className="img-fluid" alt="logo" />
                    </Link>
                  </div>

                  <div className="hd_nav_links_cntr">
                    <Link
                      to="/about"
                      className={`hd_nav_link ${isActive("about")}`}
                    >
                      About
                    </Link>
                    <Link
                      to="/services"
                      className={`hd_nav_link ${isActive("services")}`}
                    >
                      Services
                    </Link>
                    <Link
                      to={`/projects`}
                      className={`hd_nav_link ${isActive("projects")}`}
                    >
                      Projects
                    </Link>
                    <Link
                      to="/testimonials"
                      className={`hd_nav_link ${isActive("testimonials")}`}
                    >
                      Testimonials
                    </Link>
                  </div>

                  <div className="rightside_menu">
                    <div className="header_btn_wrap">
                      <button
                        className="header-btn"
                        onClick={() => navigate("/contact-us")}
                      >
                        <span className="phone_icon">
                          <FaPhoneAlt />
                        </span>
                        <span>Contact</span>
                      </button>

                      <button
                        className="header-btn"
                        onClick={() =>
                          window.open(
                            "https://beleaftechnologies.com/",
                            "_blank"
                          )
                        }
                      >
                        <span className="web_icon">
                          <TbWorld />
                        </span>
                        <span className="">Website</span>
                      </button>
                    </div>
                  </div>
                  <div className="header_bars" onClick={handleMobileMenuOpen}>
                    <i className="fa-solid fa-bars"></i>
                  </div>
                </div>
              </Toolbar>
            </AppBar>
            <Drawer
              anchor="left"
              open={mobileMenuOpen}
              onClose={handleMobileMenuClose}
              className={`mobile-drawer ${classes.drawer} gr-mob_drawer`}
            >
              <div className={` ${classes.mobileMenu}`}>
                <div className="logo_new_sectio mobile_menu_icon">
                  <div
                    className="mobile_logo_wrap"
                    onClick={handleAboutLogoClick}
                  >
                    <img src={Logo} alt="logo" />
                  </div>
                </div>

                <div className="menu_statis">
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/about">
                      About
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/services">
                      Services
                    </Link>
                  </ListItem>
                  <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/projects">
                      Projects
                    </Link>
                  </ListItem>
                  {/* <ListItem button className="drawa">
                    <Link className="hd_nav_link" to="/testimonials">
                      Testimonials
                    </Link>
                  </ListItem> */}

                  <ListItem button className="drawa">
                    <button
                      className="header-btn"
                      onClick={() => navigate("/contact-us")}
                    >
                      <span className="phone_icon">
                        <FaPhoneAlt />
                      </span>
                      <span>Contact</span>
                    </button>
                  </ListItem>

                  <ListItem button className="drawa">
                    <button
                      className="header-btn"
                      onClick={() =>
                        window.open("https://beleaftechnologies.com/", "_blank")
                      }
                    >
                      <span className="web_icon">
                        <TbWorld />
                      </span>
                      <span className="">Website</span>
                    </button>
                  </ListItem>
                </div>
              </div>
            </Drawer>
          </header>

          <main>
            <div className="header-wrapper section-wrapper">
              <div>
                <div className="row nw_project_row m-0">
                  <div className="col-xl-3 col-lg-4 col-md-5 col-sm-6">
                    <div className="projects-sidebar">
                      <div className="getting_card_contentPro">
                        <span className="getcard_sub_subhead padding-right">
                          A quick glimpse of our.
                        </span>
                        <h1>Projects</h1>
                      </div>

                      <div className="pr_subtitle">
                        <p>Categories</p>
                        <span className="border_services"></span>
                      </div>

                      <div className="pr_sidebar_btm">
                        <div className="pr_sidebar_outer">
                          {sidebarItems.map((item) => (
                            <div
                              key={item.key}
                              className={`pr_sidebar_wrap ${
                                activeTab === item.key ? "active" : ""
                              }`}
                              onClick={() => handleTabClick(item.key)}
                            >
                              <p
                                className={
                                  activeTab === item.key ? "active" : ""
                                }
                              >
                                {item.label}
                              </p>
                              <span
                                className={
                                  activeTab === item.key ? "active" : ""
                                }
                              >
                                <i className="fa-solid fa-arrow-right"></i>
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>





              <div className="col-xl-9 col-lg-8 col-md-7 col-sm-6" ref={rightColRef}>
  <div className="row project-card-row">
   {(loading && filteredImages.length === 0) ? (
      Array.from(new Array(8)).map((_, index) => (
        <div className="col-lg-6 project-card-col" key={index}>
          <div className="card_product mob_cd_prt">
            <div className="img_div">
              <Skeleton
                variant="rounded"
                height={337}
                width="100%"
                sx={{ bgcolor: "#b8b8b833", borderRadius: "10px" }}
              />
            </div>
            <div className="pr_card_cnt_flx mt-3">
              <Skeleton
                variant="text"
                width="70%"
                height={24}
                sx={{ bgcolor: "#b8b8b833" }}
              />
              <Skeleton
                variant="circular"
                width={30}
                height={30}
                sx={{ bgcolor: "#b8b8b833" }}
              />
            </div>
          </div>
        </div>
      ))
    ) : (
      filteredImages.map((card, index) => (
      <div className="col-lg-6 project-card-col" key={index}>
  <div className="card_product mob_cd_prt">
    <div className="img_div">
      <img
        className="normal-img"
        src={card.img}
        alt={card.alt}
      />

      <video
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="gif-img video_gifchange"
      >
        <source
          src={card.gif} 
                    type="video/mp4"
        />
      </video>
    </div>

    <div className="pr_card_cnt_flx">
      <p>{card.title}</p>
      <span onClick={() => handleImageClick(card.hoverClass)}>
        <i className="fa-solid fa-expand"></i>
      </span>
    </div>
  </div>
</div>


      ))
    )}
  </div>
</div>

                </div>

                <Modal
                  open={open}
                  onClose={() => setOpen(false)}
                  // keepMounted
                  aria-labelledby="keep-mounted-modal-title"
                  aria-describedby="keep-mounted-modal-description"
                >
                  <Box className="modal_video_wrap pr_md_video_wrap">
                    <div>
                      {selectedGifItem && (
                        <div className={`gif-box `}>
                         

                          <video
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        className="projects_modal_gif"
       
      >
        <source
          src={selectedGifItem.gif} 
                    type="video/mp4"
        />
      </video>
                        </div>
                      )}
                    </div>
                  </Box>
                </Modal>
              </div>
            </div>
          </main>
        </section>
      </div>
    </>
  );
};

export default ProjectNew;
